export class SelectionInputTreeEditModel {
  entities: SelectionInputEntity[];
  entityValues: SelectionInputEntityValue[];
}

export class SelectionInputEntity {
  parentName: string;
  name: string;
  displayName: string;
  description: string;
  defaultValue: string;
  inputType: InputType;
}

export class SelectionInputEntityValue {
  name: string;
  value: string | null;
}

export class InputType {
  name: string;
  attributes: any;
  validator: any;
}
